import React, { useEffect, useRef, useState } from 'react'
import { casinoGames } from './casino-games'
import SectionWrapper from '../SectionWrapper/SectionWrapper'
import { Link } from 'react-router-dom'
import { useTranslation } from '../../../hooks/useTranslation'
import Utils from '../../../core/Utils'

interface CasinoGameSectionProps {
	category: string
	title?: string
	id?: string
}

const CasinoGameSection: React.FC<CasinoGameSectionProps> = ({ category, title, id }) => {
	const isMobil = Utils.isMobile()
	const [glossGameIndex, setGlossGameIndex] = useState<number | null>(null)
	const filteredGames = casinoGames.filter((game) => game.category.includes(category))

	const initialTimeoutRef = useRef<NodeJS.Timeout | null>(null)
	const intervalRef = useRef<NodeJS.Timeout | null>(null)

	const { getTexts } = useTranslation(true)

	useEffect(() => {
		if (filteredGames.length === 0) return

		const initialDelay = Math.floor(Math.random() * 4000)

		const updateGlossGameIndex = () => {
			const randomIndex = Math.floor(Math.random() * filteredGames.length)
			setGlossGameIndex(randomIndex)
		}

		initialTimeoutRef.current = setTimeout(() => {
			updateGlossGameIndex()
			intervalRef.current = setInterval(updateGlossGameIndex, 4000)
		}, initialDelay)

		return () => {
			if (initialTimeoutRef.current) {
				clearTimeout(initialTimeoutRef.current)
			}
			if (intervalRef.current) {
				clearInterval(intervalRef.current)
			}
		}
	}, [filteredGames.length])

	return (
		<SectionWrapper title={title ?? category} id={id}>
			{filteredGames.map((game, index) =>
				isMobil ? (
					<Link
						to={`/game/${game.ext_id}`}
						key={game.ext_id}
						className={`game ${index === glossGameIndex ? 'gloss' : ''}`}
						style={{ backgroundImage: `url('${process.env.PUBLIC_URL}/${game.thumbnail_url}')` }}
					></Link>
				) : (
					<div key={game.ext_id} className={`game ${index === glossGameIndex ? 'gloss' : ''}`} style={{ backgroundImage: `url('${process.env.PUBLIC_URL}/${game.thumbnail_url}')` }}>
						<div className="game-overlay">
							<Link to={`/game/${game.ext_id}`}>
								<div className="btn">{getTexts('play')}</div>
							</Link>
						</div>
					</div>
				)
			)}
		</SectionWrapper>
	)
}

export default CasinoGameSection
